module.exports = __webpack_public_path__ + "static/media/logo_light.b466c33e.svg";